import { Injectable, inject } from '@angular/core';

import { Decimal } from 'decimal.js';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetslipType } from '../../../../../core/betslip-type';
import { ISucceededSlipResult } from '../../../../betplacement/models';
import { IResultSucceededSlipSummaryViewModel } from '../../../models/result-succeeded-slip.model';
import { UsedTokenPayoutSummaryService } from '../../../services/used-token-payout-summary.service';

@Injectable()
export class DigitalResultSummaryService {
    private messagesProvider = inject<ILinearBetslipMessagesProviderService>(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN);
    private usedTokenPayoutSummaryService = inject(UsedTokenPayoutSummaryService);

    getSummaryViewModel(slip: ISucceededSlipResult, betslipType: BetslipType): IResultSucceededSlipSummaryViewModel {
        const totalOddsTitle = this.messagesProvider.getMessages().betslip.result.totalOdds;
        const totalStake = slip.totalStake;
        const stakePerBet = slip.stake;
        const possibleWinningsNet = slip.possibleWinnings?.net ?? 0;
        const possibleWinningsGross = slip.possibleWinnings?.gross ?? 0;
        const viewModel: IResultSucceededSlipSummaryViewModel = {
            betType: betslipType,
            stake: totalStake,
            stakePerBet,
            possibleWinnings: {
                title: '',
                value: new Decimal(possibleWinningsNet),
            },
            possibleWinningsGross: new Decimal(possibleWinningsGross),
            rewardTokenInfo: undefined,
        };

        if (slip.picks.length > 1 && slip.totalOdds) {
            // Multi pick bet
            viewModel.odds = {
                title: totalOddsTitle,
                value: slip.totalOdds,
            };
        }

        return this.usedTokenPayoutSummaryService.getViewModelWithTokenInfo(slip, viewModel);
    }
}
